<template>
  <v-card class="kiw-form-card">
    <v-card-title
      class="pb-0"
      primary-title
    >
      <div>
        Formularz KIW <span v-if="value.reference">(Wniosek nr {{ value.reference }})</span>
      </div>

      <AppStatus
        v-if="value.status"
        :status-text="value.status"
        class="caption"
      />
    </v-card-title>

    <v-card-text class="pb-0">
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Nazwa projektu *</label>
          <v-text-field
            :value="value.name"
            v-bind="props.validatedField"
            :rules="[rules.required]"
            :disabled="disabled"
            placeholder="Podaj nazwę"
            @input="update('name', $event)"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Departament *</label>
          <v-select
            :value="value.departmentId"
            :items="filtersOptions.departments"
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            placeholder="Wybierz departament"
            v-bind="props.select"
            :hide-details="false"
            height="40"
            :disabled="disabled"
            @input="update('departmentId', $event)"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Cel przekazania materiału *</label>
          <v-select
            :value="value.purpose"
            :items="filtersOptions.visualNumberRequestsPurposes"
            item-value="id"
            item-text="label"
            :rules="[rules.required]"
            placeholder="Wybierz cel"
            v-bind="props.select"
            :hide-details="false"
            height="40"
            :disabled="disabled"
            @input="update('purpose', $event);"
          />
        </v-col>
        <v-col
          v-if="isPurposeCustom"
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Własny  Cel przekazania materiału*</label>
          <v-text-field
            :value="value.customPurpose"
            v-bind="props.validatedField"
            :rules="[rules.required]"
            :disabled="disabled"
            placeholder="Wprowadź cel"
            @input="update('customPurpose', $event);"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!disabled || value.embargo"
        class="mt-n10"
      >
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Embargo do:</label>
          <v-menu
            ref="datePicker"
            v-model="isDatePickerShown"
            transition="scale-transition"
            offset-y
            z-index="11"
            v-bind="props.datePickerMenu"
          >
            <template #activator="{ on, attrs }">
              <div v-on="!disabled && on">
                <v-text-field
                  :value="value.embargo | displayDate"
                  persistent-hint
                  v-bind="{
                    ...(!disabled && attrs),
                    ...props.validatedField
                  }"
                  :disabled="disabled"
                  :class="{'input-calendar': !disabled}"
                  readonly
                  placeholder="Wybierz datę"
                  append-icon="mdi-calendar-month-outline"
                  @input="update('embargo', $event)"
                />
              </div>
            </template>
            <v-date-picker
              v-model="value.embargo"
              v-bind="props.datePicker"
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';
import AppStatus from '@/components/UI/AppStatus.vue';

export default {
  components: {
    AppStatus,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      props,
      rules,
      isDatePickerShown: false,
    };
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),

    isPurposeCustom() {
      const id = this.value.purpose;
      return this.filtersOptions.visualNumberRequestsPurposes.find((p) => p.id === id)?.custom;
    },
  },

  watch: {
    isPurposeCustom(newValue) {
      if (!newValue) this.update('customPurpose', '');
    },
  },

  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value });
    },
  },
};
</script>
